module.exports = __webpack_public_path__ + "static/media/schoolpic01@2x.5c16b062.png";